import { Fragment, type FC } from 'react'
import { noop } from 'lodash'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import type { TText } from './types'

// Renders **bold** segments as <strong>, leaving the rest as plain text.
// No-op for strings without markers, so it's safe for every translation.
const renderRichText = (value: string) => {
  if (!value.includes('**')) return value

  return value
    .split(/\*\*([\s\S]+?)\*\*/g)
    .map((part, index) => (index % 2 === 1 ? <strong key={index}>{part}</strong> : <Fragment key={index}>{part}</Fragment>))
}

const Text: FC<TText> = ({
  LText,
  RText,
  emptyTag,
  text = '',
  LeftIcon,
  role = '',
  children,
  RightIcon,
  dataTestId,
  tagName = 'p',
  className = '',
  onClick = noop,
}) => {
  const { t } = useTranslation()

  const Tag = tagName

  const content = (
    <Fragment>
      {LText && LText}
      {renderRichText(t(text))}
      {RText && RText}
    </Fragment>
  )

  return Tag && !emptyTag ? (
    <Tag
      onClick={onClick}
      data-testid={dataTestId}
      className={classNames({ [className]: className })}
      role={(tagName === 'button' && 'button') || role}
    >
      {LeftIcon && <LeftIcon />}

      {content}

      {children}

      {RightIcon && <RightIcon />}
    </Tag>
  ) : (
    content
  )
}

export default Text
